import deepmerge from "deepmerge";

// Obtener oferta
const oferta = require(`./${_BBVA_CAMP}.js`).default;
const ofertaPersonales = require(`./ofertaPersonales.js`).default;

export default deepmerge(ofertaPersonales, oferta);
